module.exports = __webpack_public_path__ + "img/mir.22c1a03.svg";